const GEMINI_KEY = process.env.REACT_APP_GEMINI_KEY;
const MODEL = "gemini-2.5-flash";
const ENDPOINT = `https://generativelanguage.googleapis.com/v1beta/models/${MODEL}:generateContent?key=${GEMINI_KEY}`;

export async function askGemini(prompt) {
  if (!GEMINI_KEY) throw new Error("Missing REACT_APP_GEMINI_KEY");
  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      contents: [{ parts: [{ text: prompt }] }],
      generationConfig: { temperature: 0.2, maxOutputTokens: 4096 },
    }),
  });
  if (!res.ok) throw new Error(`Gemini API error: ${res.status}`);
  const data = await res.json();
  return data.candidates?.[0]?.content?.parts?.[0]?.text ?? "";
}

export async function askGeminiJSON(prompt) {
  let raw = await askGemini(prompt);
  // Strip markdown code fences (```json ... ```)
  raw = raw.replace(/```(?:json)?\s*/gi, "").replace(/```/g, "").trim();
  const match = raw.match(/\{[\s\S]*\}|\[[\s\S]*\]/);
  if (!match) throw new Error("No JSON found in Gemini response");
  return JSON.parse(match[0]);
}
